var apiUrl=process.env.VUE_APP_apiUrl;
var apiPathBase="api/UBossBkApi/";
import AxiosManager from "@/pages/common/axiosLib/axiosManager";
import * as ubossCommon from "@/pages/commonUBoss/ubossCommon";
import ubossCrudApiManager from "@/pages/commonUBoss/ubossCrudApiManager";

export default {

    //---------------axios------------------------
    getAxiosManager(){
        return new AxiosManager(ubossCommon.SessionKeyPrefix_Bk + ubossCommon.TokenKeyLastFix)
    },
    //---------------------------------------
    getApiManager_General() {
        return new ubossCrudApiManager(apiUrl,apiPathBase,"User", this.getAxiosManager(),null)
    },

    //---------------user------------------------

    async api_SendConfirmCode ( sClientKey, sTel)
    {
        var sendData={
            sClientKey:sClientKey,
            sTel:sTel,
        };
        return this.getApiManager_General().api_CallMethod_ByParamObj("SendConfirmCode",sendData);
    },

    async api_UserReg_Check_ConfirmCode ( sClientKey, sConfirmCode)
    {
        var sendData={
            sClientKey:sClientKey,
            sConfirmCode:sConfirmCode,
        };

        return this.getApiManager_General().api_CallMethod_ByParamObj("UserReg_Check_ConfirmCode",sendData);
    },

    async api_UserReg_Check_LoginId ( sLoginId)
    {
        var sendData={
            sLoginId:sLoginId,
        };

        return this.getApiManager_General().api_CallMethod_ByParamObj("UserReg_Check_LoginId",sendData);
    },

    async api_User_Reg ( memberRecordWebInput)
    {
        return this.getApiManager_General().api_CallMethod_SendObj("User_Reg",memberRecordWebInput);
    },

    async api_User_Login ( sLoginId, sPwd)
    {
        var sendData={
            sLoginId:sLoginId,
            sPwd:sPwd,
        };

        return this.getApiManager_General().api_CallMethod_ByParamObj("User_Login",sendData);
    },

    async api_User_ResetPwd (sLoginId )
    {
        var sendData={
            sLoginId:sLoginId
        };
        return this.getApiManager_General().api_CallMethod_ByParamObj("User_ResetPwd",sendData);
    },

    async api_User_ChangePwd ( sCurrentPwd, sNewPwd)
    {
        var sendData={
            sCurrentPwd:sCurrentPwd,
            sNewPwd:sNewPwd,
        };

        return this.getApiManager_General().api_CallMethod_ByParamObj("User_ChangePwd",sendData);
    },

    async api_UserBasicInfoGet ()
    {
        return this.getApiManager_General().api_CallMethod("UserBasicInfoGet");
    },

    async api_UserBasicInfoSave ( UserRecordBasicInfo)
    {
        return this.getApiManager_General().api_CallMethod_SendObj("UserBasicInfoSave",UserRecordBasicInfo);
    },


    //---------------OnePage------------------------
    async api_CustomerSetting ()
    {
        return this.getApiManager_General().api_CallMethod("CustomerSetting")
    },

    //---------------------------------------
    getApiManager_MarketingQRTicketType() {
        return new ubossCrudApiManager(apiUrl,apiPathBase,"MarketingQRTicketType", this.getAxiosManager(),null)
    },

    async api_MarketingQRTicketType_ListQuery ( queryObject)
    {
        return this.getApiManager_MarketingQRTicketType().api_ListQuery(queryObject);
    },

    async api_MarketingQRTicketType_Get ( systemId)
    {
        return this.getApiManager_MarketingQRTicketType().api_Get(systemId);
    },

    async api_MarketingQRTicketType_Save ( record)
    {
        return this.getApiManager_MarketingQRTicketType().api_Save(record);
    },

    async api_MarketingQRTicketType_Remove ( systemId)
    {
        return this.getApiManager_MarketingQRTicketType().api_Remove(systemId);
    },

    //---------------------------------------
    async api_DownloadQR_Pdf(systemId) {
        var apiPath=apiPathBase +"DownloadQR_Pdf?systemId=" + systemId;

        window.open(apiUrl+apiPath,"_blank")
    },
    async api_DownloadQR_Zip(systemId) {
        var apiPath=apiPathBase +"DownloadQR_Zip?systemId=" + systemId;

        window.open(apiUrl+apiPath,"_blank")
    },
    async DownloadQR_Txt(systemId) {
        var apiPath=apiPathBase +"DownloadQR_Txt?systemId=" + systemId;

        window.open(apiUrl+apiPath,"_blank")
    },
}
